import React, { useEffect } from 'react';
import KeycloakService from './KeycloakService';

function App() {
  useEffect(() => {
      document.title = "Raheja QBE";
    const init = async () => {
      const authenticated = await KeycloakService.initKeycloak(() => {});
      if (!authenticated) return;

      const token = KeycloakService.getToken();
      const parsed = KeycloakService.getAccessTokenParsed();
      const refresh = KeycloakService.getRefreshToken();


      const userId = parsed?.sub || '';
      const username = parsed?.preferred_username || 'Unknown';

const email = parsed?.email || 'Unknown';
      
      // Extract the phone number from the parsed token
      const phoneNumber = parsed?.phone_number || '';

      //const userRoles = await fetchUserRoles(token, userId);

      // Pass the phoneNumber to insertUserDetails
      await insertUserDetails(
        userId,
       // username,
        token,
        refresh,
      //  email,
      //  phoneNumber
      );
    };

    init();
  }, []);

  // const fetchUserRoles = async (token, userId) => {
  //   if (!userId) return [];

  //   try {
  //     const res = await fetch(
        
  //       `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_AVO_USER_ROLES}/${userId}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           'Ocp-Apim-Subscription-Key':
  //             process.env.REACT_APP_APIM_SUBSCRIPTION_KEY,
  //         },
  //       }
  //     );
  //     return res.ok ? await res.json() : [];
  //   } catch {
  //     return [];
  //   }
  // };

  // Update insertUserDetails to accept phoneNumber
  const insertUserDetails = async (
    userId,
   // username,
    token,
    refreshToken,
    email,
   // phoneNumber
  ) => {
    const payload = {
      userId,
   //   username,
      token,
      refreshToken,
    //  email,
     // phoneNumber: phoneNumber,
    };

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_INSERT_USER_API}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Ocp-Apim-Subscription-Key':
              process.env.REACT_APP_APIM_SUBSCRIPTION_KEY,
          },
          body: JSON.stringify(payload),
        }
      );
      debugger
      //const encryptedId = await res.text();
const result = await res.json();
if (
  res.ok &&
  result.status &&
  result.message &&
  result.message !== 'Something went wrong with encryption'
) {
  window.location.href = `${process.env.REACT_APP_REDIRECT_URL}?Id=${encodeURIComponent(
    result.message
  )}`;
} else {
  debugger
        alert('Something went wrong. Please contact the administrator.');
      }
    } catch {
      debugger
      alert('Something went wrong. Please contact the administrator.');
    }
  };

// const encryptedId = (await res.text()).trim();
// debugger
//   if (
//     res.ok &&
//     encryptedId &&
//     encryptedId !== 'Something went wrong with encryption'
//   ) {
//     window.location.href = `${process.env.REACT_APP_REDIRECT_URL}?Id=${encodeURIComponent(encryptedId)}`;
//   } else {
//     alert('Something went wrong. Please contact the administrator.');
//   }
// } catch (err) {
//   console.error(err);
//   alert('Something went wrong. Please contact the administrator.');
// }
//   };

  return null; // This component does not render any UI, only handles logic and redirection
}

export default App;
